import { useEffect as m } from "react";
import { useLatestValue as c } from './use-latest-value.js';

function d(e, r, n) {
  var o = c(r);
  m(function () {
    function t(u) {
      o.current(u);
    }

    return document.addEventListener(e, t, n), function () {
      return document.removeEventListener(e, t, n);
    };
  }, [e, n]);
}

export { d as useDocumentEvent };